/* global google */
( function( $ ) {
	const imageGalleryEle = document.querySelector( '.facility-image-gallery' );
	if( !imageGalleryEle ) { return; }

	// Note: Assuming only one imageGalleryEle per page
	const fullscreenModalEle = imageGalleryEle.querySelector( '.facility-image-gallery__fullscreen-modal' );
	const googleWrap = imageGalleryEle.querySelector( '.facility-image-gallery__google' );

	if( fullscreenModalEle ) { 
		initGallery();

		// The image(s) may not have actually loaded yet, but they have height/width values so the space they're taking up is accounted for already
		window.dispatchEvent( new Event( 'facility-image-gallery-loaded' ) );


	} else {
		initGooglePlaceImage();
	}

	function initGallery() {
		const carouselEle = fullscreenModalEle.querySelector( '.carousel' );

		$( fullscreenModalEle ).on( 'show.bs.modal', function() { // Using JQuery due to the use of a bootstrap event
			// Initialize Carousel once, when the modal opens
			$( carouselEle ).carousel( { // Using JQuery due to the use of a bootstrap function
				interval: false,
				ride: false,
				wrap: true
			} );
		} ).on( 'show.bs.modal', function( e ) {
			// Start on the image that was clicked
			const closestDiv = e.relatedTarget.closest( 'div' );
			const i = Array.from( closestDiv.parentElement.children ).indexOf( closestDiv );
			$( carouselEle ).carousel( i );
		} ).on( 'hidden.bs.modal', function() {
			var modal = imageGalleryEle.querySelector( '.modal.show' );
			if( modal ) {
				// Bootstrap removes modal-open when any modal is closed, but these are stacked
				document.body.classList.add( 'modal-open' );
			}
		} );
	}

	function initGooglePlaceImage() {
		const key = googleWrap.dataset.key;
		
		window.googleLoaded = googleLoaded; // callback for google script

		const script = document.createElement( 'script' );
		script.src = 'https://maps.googleapis.com/maps/api/js?key='+key+'&libraries=places&callback=googleLoaded';
		document.body.appendChild( script );
	}

	function googleLoaded() {
		const address = googleWrap.dataset.address;
		const service = new google.maps.places.PlacesService( googleWrap );
		service.findPlaceFromQuery( { 
			query: address,
			fields: ['name', 'photos']
		}, function( results, status ) {
			if ( status === google.maps.places.PlacesServiceStatus.OK ) {
				if( results[0].photos ) {
					const src = results[0].photos[0].getUrl( {'maxWidth': 700} );
					const img = document.createElement( 'img' );
					img.setAttribute( 'src', src );
					img.setAttribute( 'width', results[0].photos[0].width );
					img.setAttribute( 'height', results[0].photos[0].height );
					img.setAttribute( 'alt', results[0].name );

					googleWrap.append( img );

					// wait a beat to actually append the image
					setTimeout( function() {
						googleWrap.setAttribute( 'aria-busy', false );

						window.dispatchEvent( new Event( 'facility-image-gallery-loaded' ) );
					}, 1 );

				} else {
					// No photo data returned, fall back to map
					initGoogleMap( address );
				}
			} else {
				// API error, fall back to map
				initGoogleMap( address );
			}
		} );
		
	}

	function initGoogleMap( address ) {
		const key = googleWrap.dataset.key;

		const iframe = document.createElement( 'iframe' );
		iframe.setAttribute( 'frameborder', 0 );
		iframe.setAttribute( 'src', 'https://www.google.com/maps/embed/v1/place?q='+address+'&key='+key );
		iframe.setAttribute( 'allowfullscreen', true );
		
		googleWrap.append( iframe );
		googleWrap.setAttribute( 'aria-busy', false );

		window.dispatchEvent( new Event( 'facility-image-gallery-loaded' ) );
	}
} )( jQuery );